import { collection, addDoc, getDocs, query, orderBy, limit, startAfter } from "firebase/firestore"; 
import { firebaseStore } from "util/firebaseUtil";

export const homeReadDocument = async (keyword: string) => {
    return await getDocs(collection(firebaseStore, keyword));
  }